module.exports = __webpack_public_path__ + "media/images/emblems/Ins-coat_of_arms-8dd57202be5199a5fe320f5856305f28.svg";